// @ts-nocheck
import Checkbox, { CheckboxProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import { CompanyLocation, CustomerLocation } from "@store/Framework/Store/Bunzl/Pages/Reporting/LoadLocations";

import React from "react";
import { css } from "styled-components";

interface Props {
    company: CompanyLocation;
    selectedItems: string[];
    toggleAllCompanyCustomers: (customerLocations: CustomerLocation[]) => void;
}
interface CheckBoxModalGroupTitleStyles {
    checkbox?: CheckboxProps;
}
// Incredibly awkward.  Accordion is styled in the theme by having all elements inside the header button change their color to
// the theme's primary color.  The fill of the checkbox icon is white, so it needs to be overridden to be visible.
const checkboxModalGroupTitleStyles: CheckBoxModalGroupTitleStyles = {
    checkbox: {
        iconProps: {
            css: css`
                svg * {
                    fill: white;
                }
            `,
        },
    },
};
const CheckboxModalPickerGroupTitle: React.FC<Props> = ({ company, selectedItems, toggleAllCompanyCustomers }) => {
    const companySelectStatus = (company: CompanyLocation, selectedItems: string[]): boolean | "indeterminate" => {
        const companyCustomers = getCompanyCustomers(company);

        const companySelectedItems = companyCustomers.filter(customer => {
            const isSelected = selectedItems.includes(customer.id);

            return isSelected;
        });
        if (companySelectedItems.length > 0) {
            if (companySelectedItems.length === companyCustomers.length) {
                return true;
            }
            return "indeterminate";
        }

        return false;
    };

    const getCompanyCustomers = (company: CompanyLocation) => {
        return company.customers;
    };

    return (
        <>
            <Checkbox
                checked={companySelectStatus(company, selectedItems)}
                onChange={() => toggleAllCompanyCustomers(company.customers)}
                {...checkboxModalGroupTitleStyles.checkbox}
            >
                {company.name}
            </Checkbox>
        </>
    );
};

export default CheckboxModalPickerGroupTitle;
